/**
 * Holds info about the supported external search APIs
 */
export interface ExternalImageSearchApiConfig {
  /**
   * The key is a short-term for the service used, i.e. 'cc' for CC Image Search or 'flickr' for FLickr. Should not change!
   */
  [key: string]: {
    /**
     * The name of the API as shown in texts
     */
    name: string;
    /**
     * The API endpoint
     */
    url: string;
    /**
     * A public key if necessary
     */
    publicKey?: string
  };
}

/**
 * The actual config for external image search apis
 */
export const ExternalImageSearchApis: ExternalImageSearchApiConfig = {
  cc: {
    name: 'Openverse Image Search',
    url: '/api/openverse/v1/images/'
  },
  flickr: {
    name: 'Flickr Public Image Search',
    url: '/api/flickr/services/rest/',
    publicKey: 'bc74556d96120702fa64809ce374042c'
  }
  // duckduckgo: {
  //   name: 'Duckduckgo Image Search',
  //   url: 'http://127.0.0.1/search/', // TODO add real address of backend
  // },
  // google: {
  //   name: 'Googe Image Search',
  //   url: 'http://127.0.0.1/search/', // TODO add real address of backend
  // }
};
